<template>
  <div @click="handleClick" :class="['concept', 'concept--has-shadows', isFocused]" :id="concept.id" :style="{'--yDist': yDistVal + 'px', '--scale': scaleVal, '--opacity': opacityVal, '--z': zIndexVal, '--pointerEvents': pointerEvents}">
    <div class="concept-inner-container">
      <div class="details">
        <div class="meta">
          <div class="number">{{ $store.state.org.numberPrefix }}-{{ numberPadded }}</div>
          <div class="counts">
            <div>{{ ideaCountLabel }}<span class="symbol symbol--is-square"></span></div>
            <div>{{ referenceCountLabel }}<span class="symbol symbol--is-circle"></span></div>
          </div>
        </div>
        <div class="headers">
          <h1>{{concept.name}}</h1>
          <p class="sub-header">{{description}}</p>
        </div>
      </div>

      <div class="collage">
        <div class="blocks">
          <Block
            v-for="(block, index) in collageBlocks"
            v-bind:block="block"
            v-bind:index="index"
            v-bind:key="block.id"
            v-bind:viewActions="false"
            small="small"
            v-bind:inConceptId="this.concept.id"
          ></Block>
        </div>
      </div>
    </div>
    <div class="concept__shadows">
      <div class="concept__shadows-inner"></div>
      <div class="concept__shadows-outer"></div>
    </div>
  </div>
</template>

<script>
import Block from '@trust/components/Block.vue'
// import Editable from '@trust/components/Editable.vue'

export default {
  name: 'ConceptCard',
  components: {
    // Editable,
    Block,
  },
  props: ['concept', 'index', 'id', 'currentPosition'],
  data(){
    return {
      opacityDelta: 0.1,
      yDelta: 24,
      zDelta: 10,
      scaleDelta: 0.1,
    }
  },
  computed: {
    ideaCountLabel(){
      let ideaBlocks = [];
      if(this.$store.state.org.blocks){
        ideaBlocks = this.$store.state.org.blocks.filter(function(block){
          if(block.concepts) {
            return block.concepts.includes(this.concept.id) && (block.type == 'Idea' || block.type == undefined);
          }

          return false;
        }.bind(this));
      }

      // let label = 'Ideas ' + ideaBlocks.length;
      // if(ideaBlocks.length > 1) { label += 's'}
      return ideaBlocks.length;
    },
    referenceCountLabel(){
      let refBlocks = [];
      if(this.$store.state.org.blocks){
        refBlocks = this.$store.state.org.blocks.filter(function(block){
          if(block.concepts) {
            return block.concepts.includes(this.concept.id) && (block.type == 'Reference');
          }

          return false;
        }.bind(this));
      }

      // let label = 'References ' + refBlocks.length;
      // if(refBlocks.length > 1) { label += 's'}
      return refBlocks.length;
    },
    description(){
      return this.concept.description || "No description"
    },
    isFocused(){
      if(this.currentPosition == this.index && !this.isMobile()) {
        this.$store.commit('setViewingConcept', { conceptId: this.concept.id });
        return 'focused';
      } else {
        return '';
      }
    },
    positionDifference(){
      return Math.abs(this.currentPosition - this.index);
    },
    opacityVal(){
      if (this.currentPosition > this.index) {
        return 0;
      } else {
        return (1 - (this.opacityDelta * this.positionDifference));
      }
    },
    yDistVal(){
      if (this.currentPosition > this.index) {
        return this.yDelta;
      } else {
        return (0 - (this.yDelta * this.positionDifference));
      }
    },
    scaleVal(){
      if (this.currentPosition > this.index) {
        return 1 + this.scaleDelta;
      } else {
        return (1 - (this.scaleDelta * this.positionDifference));
      }
    },
    zIndexVal(){
      if (this.currentPosition > this.index) {
        return this.zDelta;
      } else {
        return (1 - (this.zDelta * this.positionDifference));
      }
    },
    pointerEvents(){
      if (this.currentPosition > this.index) {
        return 'none';
      } else {
        return 'all';
      }
    },
    collageBlocks(){

      let allBlocks = [];
      if(this.$store.state.org.blocks){
        allBlocks = this.$store.state.org.blocks.filter(function(block){
          if(block.concepts) {
            return block.concepts.includes(this.concept.id) && (block.type == 'Idea' || block.type == undefined);
          }

          return false;
        }.bind(this));

        allBlocks.sort(function(a, b) {
          if (a.createdAt > b.createdAt) return -1;
          if (a.createdAt < b.createdAt) return 1;
          return 0;
        });
      }

      let threeBlocks = [];
      for(let i = 0; i < 3; i++){
        if(allBlocks[i]){
          threeBlocks.push(allBlocks[i]);
        }
      }
      return threeBlocks;

    },
    numberPadded(){
      let num = this.concept.number;
      return String(num).padStart(3, '0');
    }
  },
  methods: {
    handleClick(){
      if(this.currentPosition == this.index) {
        this.$store.dispatch('closeLeftAndRight');
        this.$emit('goToConcept');
      } else {
        this.$emit('scrollToConcept');
      }
    },
    isMobile(){
      if(window.innerWidth <= 600){
        return true;
      } else {
        return false;
      }
    },
  },
  mounted () {
    this.$el.addEventListener('mousewheel', (e) => {
      e.preventDefault();
      this.$emit('scrolled', { event: e });
    });
  }
}
</script>


// Scratchpad for calculating opacityVal scenarios
//
// at position 0  and we're 0  opacity: 1
// at position 1  and we're 0  opacity: 0
// at position 2  and we're 0  opacity: 0

// at position 0  and we're 2  opacity: 1-0.1-0.1  2
// at position 1  and we're 2  opacity: 1-0.1      1
// at position 2  and we're 2  opacity: 1          0
// at position 3  and we're 2  opacity: 0          1


<style>

  .concept {
    display: flex;
    width: 100%;
    position: absolute;
    top: 0;
    opacity: var(--opacity);
    transform: translateY(var(--yDist)) scale(var(--scale));
    z-index: var(--z);
    pointer-events: var(--pointerEvents);
    transform-origin: top center;

    /* filter: drop-shadow(0px -34px 74px rgba(185, 185, 185, 0.25)); */
    transition: all 200ms ease-in-out;
  }

  .concept:hover {
    cursor: pointer;
  }

  .concept-inner-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    transform-origin: top center;
    position: relative;
    transition: all 200ms ease-in-out;

    background: var(--beige-200);
    border: 2px solid var(--beige-900);
    box-shadow: 0px -4px 6px rgba(203, 183, 159, 0.21), inset 0px 6px 8px rgba(255, 251, 247, 0.8);
    border-radius: 40px;
    max-height: 55vh;
    overflow: hidden;
  }

  .concept.focused:hover .concept-inner-container {
    transform: scale(1.03);
  }

  .concept .selects {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .concept .details {
    width: 100%;
    position: relative;
    padding: 16px;
    box-sizing: border-box;
  }

  .concept .details .meta {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-family: 'Lettera', monospace;
    font-weight: 400;
    font-size: 16px;
    color: var(--beige-450);
    padding: 26px;
    padding-top: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  .concept .details .meta .number {
    font-family: 'Lettera', monospace;
    font-weight: 400;
    font-size: 16px;
    color: var(--beige-450);
  }

  .concept .details .meta .counts {
    text-align: right;
  }

  .concept .details .meta .counts .symbol {
    margin-left: 8px;
  }


  .concept .details .headers {
    padding-top: 0;
    transition: all 200ms ease-in-out;
  }

  .concept .details .headers h1 {
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0px;
    transition: all 200ms ease-in-out;
  }

  .concept .details .headers .sub-header {
    opacity: 0;
    line-height: 120%;
    transition: all 200ms ease-in-out;
  }

  .concept.focused .details .headers .sub-header {
    opacity: 1;
  }

  .concept.focused .details .headers {
    padding-top: 40px;
  }

  .concept.focused .details .headers h1 {
    font-size: 52px;
  }



  .concept__shadows {
    display: flex;
    width: 100%;
    align-items: center;
    position: absolute;
    bottom: 0;
    z-index: -10;
    opacity: 1;
    transition: all 200ms ease-in-out;
  }


  .concept__shadows-inner,
  .concept__shadows-outer {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    border-radius: 50%;
    filter: blur(16px);
  }
  .concept__shadows-inner {
    width: 60%;
    height: 35px;
    background: rgba(203, 183, 159, 0.7);
    filter: blur(10px);
  }

  .concept__shadows-outer {
    width: 95%;
    height: 60px;
    background: rgba(203, 183, 159, 0.5);
  }

  /* .concept.focused.concept__shadows{
    opacity: 1;
  }
   */



  .concept .identifiers {
    display: grid;
    grid-template-columns: 1fr 4fr 1fr;
    align-items: baseline;

    padding-top: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    opacity: 0.8;
    transition: all 200ms ease-in-out;
  }

  .concept .identifiers .number {

  }

  .concept .identifiers h1 {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0px;
    margin: 0;
    transition: all 200ms ease-in-out;
  }

  .concept.focused .identifiers {
    padding-top: 16px;
    opacity: 1;
  }

  .concept.focused .identifiers h1 {
    font-size: 50px;
  }

  .concept.concept-view .identifiers {
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
    opacity: 1;
  }



  .concept .details {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .concept .details p {
    align-self: center;
    font-size: 28px;
    text-align: center;
    margin: 8px;
  }

  .concept .grid {
    padding: 40px;
    box-sizing: border-box;
  }

  .concept .grid .blocks {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
  }

  .concept .collage {
    padding: 40px;
    box-sizing: border-box;
  }

  .concept .collage .blocks {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    margin-left: 60px;
    height: 180px;
  }

  .concept .collage .blocks .box {
    border: 2px solid var(--beige-200);
  }

  .concept .collage .blocks .title {
    display: none;
  }

  .concept .collage .blocks .block:nth-child(2) {
    transform: translate(-40px, -30px);
    z-index: 2;
  }

  .concept .collage .blocks .block:nth-child(3) {
    transform: translate(-73px,20px);
    z-index: 0;
  }


</style>
